<template>
<!--  <div class="form-group" :class="classFormGroup">-->
  <div  :class="classFormGroup">
    <label v-if="label && labelPosition === 'top'" :class="classLabel">
      {{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="validation?.$error" style="color: red; padding-left: 10px;">
        {{ messages }}
      </span>
      <span v-if="validationMessage" style="color: red; padding-left: 10px;">
        {{ validationMessage }}
      </span>
    </label>

<!--    <div :class="{ 'd-flex align-items-start ': labelPosition === 'right',}">-->
    <label :class="{ 'd-flex align-items-center ': labelPosition === 'right'}" class="custom-checkbox">
      <!--          class="form-control" -->
      <input
          type="checkbox"
          :checked="modelValue"
          @input="handleInput"
          :disabled="disabled"
          v-bind="$attrs"
          :style="inputStyle"
          :class="[{ 'is-invalid': validation?.$error}, classInput]"/>
      <div class="custom-check-icon" :class="disabled ? 'disabled' : ''"></div>
      <label v-if="label && labelPosition === 'right'" class="ml-2 mb-0" :class="classLabel">
        {{ label }}
        <span v-if="required" style="color: red;"> *</span>
        <span v-if="validation?.$error" style="color: red; padding-left: 10px;">
          {{ messages }}
        </span>
        <span v-if="validationMessage" style="color: red; padding-left: 10px;">
          {{ validationMessage }}
        </span>
      </label>
    </label>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  modelValue: {
    type: [ String, Number, Boolean, null ],
    required: true,
    default: false,
  },
  label: {
    type: [ String, Boolean ],
    default: false,
  },
  labelPosition: {
    type: String,
    default: 'top', // 'top' or 'right'
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  classFormGroup: {
    type: String,
    default: '',
  },
  classLabel: {
    type: String,
    default: 'w-100',
  },
  classInput: {
    type: String,
    default: '',
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  messages: {
    type: [ Object, String, Array ],
    default: () => ({}),
  },
  validationMessage: {
    type: [ String, null ],
    default: '',
  },
  inputStyle: {
    type: Object,
    default: () => ({
      transform: 'scale(1.1)', // Default checkbox size
    }),
  },
});

const emit           = defineEmits([ 'update:modelValue' ]);
const { modelValue } = toRefs(props);

const handleInput = (event) => {
  emit('update:modelValue', event.target.checked);
};
</script>

<style scoped>

</style>
